import React, { memo } from "react";
import WithStyles from "shared/components/WithStyles";
import { somethingWentWrongStyles } from "./styles";
import { TEXT } from "./constants";

function SomethingWentWrong() {
    return (
        <>
            <WithStyles cssProps={somethingWentWrongStyles}>
                <i className="icon-danger" />
                <p className="info">{TEXT.INFO}</p>
                <a className="cta" href="/">
                    {TEXT.BACK_LINK_LABEL}
                </a>
            </WithStyles>
        </>
    );
}

export default memo(SomethingWentWrong);
